import GeoJsonCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/GeoJsonCatalogItem";
import Terria from "../../../../lib/Models/Terria";
import ViewState from "../../../../lib/ReactViewModels/ViewState";
import { BottomDockChart } from "../../../../lib/ReactViews/Custom/Chart/BottomDockChart";
import { renderWithContexts } from "../../withContext";
import { jsx as _jsx } from "react/jsx-runtime";
describe("BottomDockChart", function () {
  let terria;
  let viewState;
  let chartItems;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    viewState = new ViewState({
      terria,
      catalogSearchProvider: undefined
    });
    chartItems = [{
      item: {},
      id: "zzz",
      name: "zzz",
      categoryName: "ZZZ",
      key: "key-zzz",
      type: "line",
      xAxis: {
        name: "Time",
        scale: "time"
      },
      points: [{
        x: 10,
        y: 10
      }],
      domain: {
        x: [0, 100],
        y: [0, 50]
      },
      units: "time",
      isSelectedInWorkbench: true,
      showInChartPanel: true,
      updateIsSelectedInWorkbench: () => {},
      getColor: () => "#fff",
      pointOnMap: {
        latitude: -33.8688,
        longitude: 151.2093
      }
    }, {
      item: {},
      id: "aaa",
      name: "aaa",
      categoryName: "AAA",
      key: "key-aaa",
      type: "line",
      xAxis: {
        name: "Time",
        scale: "time"
      },
      points: [{
        x: 10,
        y: 10
      }],
      domain: {
        x: [0, 100],
        y: [0, 50]
      },
      units: "time",
      isSelectedInWorkbench: true,
      showInChartPanel: true,
      updateIsSelectedInWorkbench: () => {},
      getColor: () => "#fff",
      pointOnMap: {
        latitude: -37.814,
        longitude: 144.96332
      }
    }];
  });
  it("renders all points on map for active chart items", async function () {
    renderWithContexts(/*#__PURE__*/_jsx(BottomDockChart, {
      height: 100,
      initialHeight: 100,
      initialWidth: 100,
      xAxis: {
        scale: "time"
      },
      chartItems: chartItems
    }), viewState);
    const pointsOnMap = terria.overlays.items.filter(item => item instanceof GeoJsonCatalogItem);
    expect(pointsOnMap.length).toBe(2);
  });
});